import {DataCounterItemConfig} from 'filters/features/FilterTopbar/types';
import {assertPageFilter} from 'filters/types';

import {useSourceFilter, useFilterLoading} from 'filters/contexts/FilterStackProvider';
import {useFilterActionsContext} from 'filters/contexts/FilterActionsProvider/FilterActionsProvider';

import {BaseFilterTopBarItem} from 'modules/decisionsNext/components/BaseFilter/TopBar/BaseFilterTopBarItem';

export const createDataCounterItem = <V, O extends {skip?: boolean}, D>(
  config: Omit<DataCounterItemConfig<V, O, D>, 'type'>
): DataCounterItemConfig<V, O, D> => {
  return {
    ...config,
    type: 'data-counter',
  };
};

export const DataCounterItem = ({
  disabled,
  entity,
  variant,
  useData,
  getDataOptions,
  getCount,
  onClick,
  onReset,
}: DataCounterItemConfig<any, any, any>) => {
  const filter = useSourceFilter();
  const filterLoading = useFilterLoading();
  const {useApplyFilter} = useFilterActionsContext();
  const onApply = useApplyFilter();
  const {data, loading} = useData(getDataOptions(filter));
  const count = getCount(filter, data);

  if (!count) {
    return null;
  }

  return (
    <BaseFilterTopBarItem
      disabled={disabled}
      variant={variant}
      loading={filterLoading || loading}
      label={
        <>
          {entity} <b>{count}</b>
        </>
      }
      // tooltip={getTooltip?.(filter, count)}
      onClick={onClick}
      onDelete={
        onReset
          ? () => {
              assertPageFilter(filter);

              onApply(onReset(filter));
            }
          : undefined
      }
    />
  );
};
